// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
export function fetchNewslist(page: number, classId: number, category: string) {
    return http.get(
      `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
    );
  }

// export { getBaseInfo };
